export const URL_BANCOLOMBIA_PERSONAS = "https://www.bancolombia.com/personas";
export const URL_BANCOLOMBIA_PERSONAS_DEUDA =
	"https://www.bancolombia.com/personas/alternativas-financieras/negociar-deuda";
